<template>
  <div class="tusd-wrap wrap-bg">
    <div class="page-title">我的钱包</div>
    <cube-scroll ref="scroll" class="header-scroll" :options="scrollOptions" @pulling-down="refreshData">
      <div class="wallet-details">
        <div class="img"></div>
        <!-- /static/img/balance.811cbd9a.png -->
        <!-- <img :src="require('@/assets/images/balance.png')" /> -->
        <div class="wallet-balance">
          <div class="balance-title">总资产 USDT</div>
          <!-- <div class="balance-amount">{{common.randerFloat(wallet.Usdt) + common.randerFloat(wallet.Margin)}}</div> -->
          <div class="balance-amount">{{ common.toDecimal2(common.randerFloat(wallet.Usdt)) }}</div>
          <div class="tusd-btn-small tusd-btn-small-danger" @click="goPage('records')">账户明细</div>
        </div>
        <div class="available-freeze">
          <div class="available-freeze-title">可用资产</div>
          <div class="available-freeze-content">{{ common.toDecimal2(wallet.Usdt) }} USDT</div>
        </div>
        <!-- <div class="available-freeze available-freeze-right">
          <div class="available-freeze-title">保证金</div>
          <div class="available-freeze-content">{{ common.toDecimal2(wallet.Margin)}} USDT</div>
        </div> -->
        <div class="available-freeze available-freeze-right">
          <div class="available-freeze-title">换算后资产</div>
          <div class="available-freeze-content hs">{{ common.toDecimal2(wallet.TotalCNY)}} CNY</div>
        </div>
      </div>
      <div class="separator"></div>
      <!-- <div class="recharge-code recharge-code-price">
        <div class="recharge-title recharge-title-price">
          当前通道USDT/CNY 
        </div>
        <div class="recharge-address recharge-address-price">{{ wallet.SellPrice }}</div>
      </div> -->
      <div v-if="wallet.OpenTRC20Address == 1" class="recharge-code">
        <div class="recharge-title">
          充值账户TRC20地址
          <i class="qrcode-btn" @click="goPage('qrcode')"></i>
        </div>
        <div class="recharge-address">{{ wallet.TRC20Address }}</div>
        <div class="copy-address">
          <span class="tusd-btn-small" v-clipboard:copy="wallet.TRC20Address" v-clipboard:success="copySuccess"
            v-clipboard:error="copyError">复制地址</span>
          <!-- <span class="tusd-btn-small recharge" @click="recharge">划转入通道</span> -->
          <span class="tusd-btn-small recharge" @click="recharge">刷新钱包</span>
        </div>
        <div class="recharge-notice">
          注意事项：
          <br />仅接受相同币种的充值，上述地址需要12个网络节点才能确认到账，正常情况，需要10分钟。<br />
        </div>
      </div>
      <!-- <div class="withdraw-wrap">
        <div class="withdraw-title">提币</div>
        <div class="page-item">
          <cube-tip ref="tip" direction="bottom" style="top:-30px; width:100%">{{ withdraw.address }}</cube-tip>
          <span class="page-item-label">提币地址：</span>
          <input type="text" v-model="withdraw.address" ref="address" @focus="showTip" @blur="hideTip" @input="showTip"
            class="addresstxt" />
        </div>
        <div class="page-item">
          <span class="page-item-label">币安卖价：</span>
          <input type="text" v-model="wallet.SellPrice" disabled />
          <span class="send-code" @click="reflash">刷新</span>
        </div>
        <div class="page-item">
          <span class="page-item-label">提币数量：</span>
          <input type="text" v-model="withdraw.amount" @keyup="changeAmount" />
        </div>
        <div class="page-item">
          <span class="page-item-label">验证码：</span>
          <span class="send-code" @click="sendCode">{{ sendTxt }}</span>
          <input type="text" v-model="withdraw.Code" placeholder="请输入验证码" />
        </div>
        <div class="page-item">
          <span class="page-item-label">备注：</span>
          <input type="text" v-model="withdraw.Remark" />
        </div>
      
        <div class="tusd-btn" @click="withdrawFn($event)">确认提币</div>
      </div> -->
    </cube-scroll>
    <div class="rscan" v-show="hasClickScan" @click="cancelScan">退出扫描</div>

    <cube-popup type="my-popup" ref="myPopup"></cube-popup>

    <cube-popup :mask="false" type="prompt-popup" ref="promptPopup">{{ popupTxt }}</cube-popup>



  </div>
</template>

<script>
export default {
  name: "wallet",
  inject: ['reload'],
  data() {
    return {
      scrollOptions: this.$store.state.refreshOptions,
      wallet: {
        Usdt: 0,
        FrozenUsdt: 0,
        UsdtAddress: "",
        MaxNumber: 0.00,
        SellPrice: 0.00,
        RealNumber: 0.00,
        Fee: 0,
        qrCodeUrl: "",
        TRC20Address:"",
        TotalCNY:0.00,
        OpenTRC20Address:0
      },

      barcode: null,
      withdraw: {
        address: "",
        amount: "",
        Code: "",
        remark: "",
        AccoutType: _ACCOUNTTYPY_,
        SmsType: 3
      },
      send: false,
      sendTxt: "获取验证码",
      popupTxt: "",
      click: true,
      hasClickScan: false
    };
  },
  methods: {
    goPage(name) {
      this.$store.commit("storeParams", {
        name: name,
        back: "wallet",
        qrCodeUrl: this.wallet.TRC20Address
      });
      this.$router.push({ name: name });
    },
    cancelScan() {
      this.barcode.close();
      this.hasClickScan = false;
      this.$refs.myPopup.hide();
    },
    showTip() {
      this.$refs.tip.show();
    },
    hideTip() {
      this.$refs.tip.hide()
    },
    scan() {
      let that = this;
      that.$refs.myPopup.show();
      try {
        that.barcode = plus.barcode.create("barcode", [plus.barcode.QR], {
          frameColor: "#f21526",
          scanbarColor: "#f21526"
        });
        that.barcode.onmarked = (type, code) => {
          that.withdraw.address = code;
          that.barcode.close();
          that.hasClickScan = false;
          that.$refs.myPopup.hide();
        };
        that.barcode.onerror = error => {
          that.barcode.close();
          that.common.showPopup(that, "扫描失败，请重新扫描");
          that.hasClickScan = false;
          that.$refs.myPopup.hide();
        };
        plus.webview.currentWebview().append(that.barcode);
        that.barcode.start();
        that.hasClickScan = true;
      } catch (err) {
        that.common.showPopup(that, "您的手机扫描失败");
        that.barcode.close();
        that.hasClickScan = false;
        that.$refs.myPopup.hide();
      }
      that.hasClickScan = true;
    },
    refreshData() {
      this.getWallet();
    },
    copySuccess() {
      this.common.showPopup(this, "复制成功");
    },
    copyError() {
      this.common.showPopup(this, "复制失败");
    },
    changeAmount() {
      this.withdraw.amount = this.verify.enterIntOrFloat(this.withdraw.amount);
    },
    //刷新币安卖价
    reflash() {
      let that = this;
      that.$api.GetCoinUpPrice().then((res) => {
        let data = res.data;
        that.wallet.SellPrice = data.sellprice;
        that.wallet.MaxNumber = data.maxNumber;
        let msg = `当前币安的卖价<span class='spanred'>${data.sellprice}</span>,您最大转换<span class='spang1'>${data.maxNumber}</span>个币`;
        that.$message.popup(msg, 2000);
      });
    },
    sendCode() {
      let that = this;
      if (that.send) {
        return false;
      }
      let data = {
        Email: that.$store.state.userInfo.Email,
        AccoutType: _ACCOUNTTYPY_,
        SmsType: 3
      };
      that.$api.sendEmailCode(data).then((res) => {
        that.$message.popup("发送成功", 1000);
        that.send = true
        that.common.countdown(that.$store.state.sendTime, that, 'sendTxt', () => {
          that.send = false;
          that.sendTxt = '获取验证码'
        })
      });
    },
    withdrawFn(e) {
      e.currentTarget.blur();//获取当前绑定事件的元素，然后取消焦点
      let that = this;
      if (!that.withdraw.address) {
        that.common.showPopup(that, "请输入提币地址");
        return false;
      }
      if (!that.withdraw.amount || that.withdraw.amount <= 0) {
        that.common.showPopup(that, "请输入提币数量");
        return false;
      }
      if (!that.verify.verifyFloat(that.withdraw.amount)) {
        that.common.showPopup(that, "请输入0~2位小数点的正数字");
        return false;
      }
      if (that.withdraw.amount < that.wallet.Fee) {
        that.common.showPopup(that, "提取的币不能小于手续费数量");
        return false;
      }
      if (that.withdraw.amount > that.wallet.MaxNumber) {
        that.common.showPopup(that, "提取的币不能超过持有量,请刷新币安卖价");
        return false;
      }
      if (!that.withdraw.Code) {
        that.common.showPopup(that, "请输入验证码");
        return false;
      }
      that.$api.GetRealCoin(that.withdraw.amount).then(res => {
        let data = res.data;
        let msg = `当前币安的买价<span class='spanred'>${data.Buy}</span>,卖价<span class='spangreen'>${data.Sell}</span>,划转后的数量为<span class='spang1'>${data.realNumber}</span>个，确定要提币?`;
        that.$message.confirm("提示", msg, () => {
          that.$api.coinUp(that.withdraw).then(res => {
            that.$message.popup("提币成功")
            that.reload()
          })
        });
      })
    },
    getWallet() {
      let that = this;
      that.$api.getWallet().then(res => {
        let data = res.data;
        that.wallet = Object.assign(that.wallet, data);
        that.$refs.scroll.forceUpdate();
      });
    },
    //客户刷洗充值
    recharge() {
      //先提示要不要同步
      // let that = this;
      // that.$api.GetSymbol().then(res => {
      //   let data = res.data;
      //   let msg = `当前币安的买价<span class='spanred'>${data.Buy}</span>,卖价<span class='spangreen'>${data.Sell}</span>,确定要划转?`;
      //   that.$message.confirm("提示", msg, () => {
      //     that.$api.Recharge().then(res => {
      //       that.$message.popup("划转成功", 1000);
      //       that.getWallet();
      //     });
      //   });
      // })
      this.$api.refreshWallet().then(res => {
        this.$message.popup(res.msg, 2000);
        setTimeout(() => {
          window.location.reload()
        }, 2000)
        
      });
    }
  },
  created() {
    this.$parent.active = this.$store.state.routerStore.menu.active;
    this.getWallet();
    //refresh scroll
    // let img = new Image();
    // img.src = "/img/balance.811cbd9a.png";
    // img.onload = () => {
    //   this.$refs.scroll.refresh();
    // };
    //load barcode
  }
};
</script>

<style lang="less" scoped>
.recharge {
  margin-left: 20px;
  background-color: #ef8299;
}

.wallet-details {
  position: relative;
  height: 210px;
  padding: 14px 0px 16px;

  // img {
  //   display: block;
  //   height: 100%;
  //   margin: 0px auto;
  // }
  .img {
    background: url(../assets/images/balance.png) center center no-repeat;
    background-size: 100%;
    height: 100%;
    width: 45%;
    margin: 0 auto;
  }

  .wallet-balance {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    text-align: center;

    .balance-title {
      color: #96abe4;
    }

    .balance-amount {
      margin: 10px 0px 16px;
      font-size: 26px !important;
      color: #28faff;
    }
  }

  .available-freeze {
    position: absolute;
    left: 12px;
    bottom: 16px;

    .available-freeze-title {
      font-size: 14px !important;
      color: #d9e3fd;
    }

    .available-freeze-content {
      margin-top: 6px;
      font-size: 15px !important;
      color: #569eff;

      &.hs {
        color: #ef8299;
      }
    }

    &.available-freeze-right {
      bottom: 17px;
      left: auto;
      right: 12px;
    }
  }
}

.recharge-code {
  padding: 12px 12px 14px;
  border-top: 1px solid #4a5286;
  background-color: #3c4468;
  margin-bottom: 10px;
  .recharge-title {
    font-size: 16px !important;
    line-height: 26px;
    color: #fefeff;

    .qrcode-btn {
      float: right;
      width: 26px;
      height: 26px;
      background: url(../assets/images/qrcode.svg) center center no-repeat;
    }
  }

  .recharge-address {
    margin: 24px 0px 20px;
    font-size: 14px !important;
    color: #b6c1fe;
    text-align: center;
    word-break: break-all;
  }

  .copy-address {
    text-align: center;
  }

  .recharge-notice {
    margin-top: 18px;
    padding-top: 16px;
    border-top: 1px solid #444d85;
    color: #616a9e;
    font-size: 12px !important;
    line-height: @notice-height;
  }
  // .recharge-title-price{
  //   text-align: center;
  // }
  .recharge-address-price{
    margin: 10px 0;
  }
}

.recharge-code-price{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.withdraw-wrap {
  padding: 12px 12px 14px;

  .withdraw-title {
    margin-bottom: 10px;
    font-size: 16px !important;
    line-height: 26px;
    color: #fefeff;
  }

  .page-item {
    display: block;
    padding: 0px;
    position: relative;

    .scan-btn {
      float: right;
      width: 26px;
      height: 26px;
      margin-top: 10px;
      background: url(../assets/images/scan.svg) center center no-repeat;
    }

    .send-code {
      float: right;
      color: #fefeff;
    }

    input {
      border: none;
      outline: none;
      background-color: transparent;
      color: #fefeff;
    }

    input.addresstxt {
      width: calc(100% - 105px);
    }
  }

  .withdraw-notice {
    margin-top: 22px;
    color: #575f8d;
    font-size: 12px !important;
    line-height: @notice-height;
  }
}

.tusd-btn {
  margin: 30px 0px 20px;
}

.rscan {
  position: fixed;
  z-index: 1000000;
  width: 90%;
  bottom: 110px;
  background: #00a0de;
  line-height: 40px;
  color: #fff;
  font-size: 16px !important;
  text-align: center;
  border-radius: 6px;
  background-color: #00a0de;
  margin: 0 5%;
}

@media screen and (max-width: 370px) {
  .wallet-details {
    height: 196px;

    .available-freeze {
      .available-freeze-title {
        font-size: 12px !important;
      }

      .available-freeze-content {
        font-size: 13px !important;
      }
    }
  }
}</style>
<style>.cube-tip {
  padding: 7px 20px 7px 10px;
  background: rgba(60, 68, 104, 0.9);
}

.cube-tip-close {
  top: 9px;
  width: 11px;
  height: 11px;
  -webkit-transform: scale(1);
  transform: scale(1);
}

.cube-tip-content {
  text-align: center;
  font-size: 12px !important
}</style>

